interface Props {
  tonoPiel: string;
  setTonoPiel: (v: string) => void;
}

const TONO_PIEL_OPCIONES = [
  'Cálido', 'Frío', 'Neutro',
  'Cálido subtono dorado', 'Frío subtono rosa', 'Neutro oliváceo',
];

export default function TonoPielSection({ tonoPiel, setTonoPiel }: Props) {
  return (
    <div className="bg-white border border-brand-gray-200 rounded-2xl p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-brand-sage/20 flex items-center justify-center text-brand-black">
          <i className="ri-sun-line text-lg" />
        </div>
        <div>
          <h3 className="font-serif text-brand-black text-lg font-medium">Tono de piel</h3>
          <p className="font-sans text-brand-gray-500 text-xs mt-0.5">
            Define la categoría de tono para personalizar la paleta
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {TONO_PIEL_OPCIONES.map((opcion) => {
          const selected = tonoPiel === opcion;
          return (
            <button
              key={opcion}
              type="button"
              onClick={() => setTonoPiel(selected ? '' : opcion)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border font-sans text-sm transition-all ${
                selected
                  ? 'border-brand-black bg-brand-black text-white'
                  : 'border-brand-gray-200 text-brand-gray-700 hover:border-brand-black'
              }`}
            >
              {selected && <i className="ri-check-line" />}
              {opcion}
            </button>
          );
        })}
      </div>
      {tonoPiel && (
        <p className="font-sans text-brand-gray-400 text-xs mt-3">
          {tonoPiel.toLowerCase().includes('cálido') || tonoPiel.toLowerCase().includes('calido')
            ? 'Colores recomendados: dorados, terracotas, verdes bosque, marfil, cobre, naranjas suaves.'
            : tonoPiel.toLowerCase().includes('frío') || tonoPiel.toLowerCase().includes('frio')
            ? 'Colores recomendados: plateados, azules marino, rosas pálidos, grises perla, lavandas, esmeraldas.'
            : 'Colores recomendados: la gama completa de cálidos y fríos le favorece. Apuesta por neutros sofisticados.'}
        </p>
      )}
    </div>
  );
}